import * as React from 'react';
import './form-elements.scss';
import Select from 'react-select-v2';
import { Label } from 'reactstrap';

const select = ({ options, labelKey, valueKey, label, input, id, ariaLabel, defaultOption, meta: { touched, error, initial } })  => {

  return (
    
    <div className="SelectField__FieldWrapper">
        <div className={`select-ct ${touched && error && 'has-error'}`}>
        <Select 
                {...input}
                options={options}
                id={id}
                aria-owns={id}
                placeholder={''}
                valueKey={valueKey}
                labelKey={labelKey}
                onBlur={() => input.onBlur(input.value)}
                clearable={false}
                searchable={false}
                aria-label={ariaLabel ? ariaLabel : label}
                value={{value : defaultOption.value, label : defaultOption.label}}
            />
            {label !== '' && <Label className="Label__FloatedLabel" htmlFor={id}>{label}</Label>}
         </div>
        {touched && error && 
              // tslint:disable-next-line:max-line-length
         <div className="FieldError__ErrorContainer"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12" y2="16"></line></svg> {error}</div>
        }
    </div>
  );
};

export const SimplerSelectV2 = select;